import { render, staticRenderFns } from "./CreateLeadDialog.vue?vue&type=template&id=5908bb08&"
import script from "./CreateLeadDialog.vue?vue&type=script&lang=js&"
export * from "./CreateLeadDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateLeadDialog.vue?vue&type=style&index=0&id=5908bb08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports